const ZoomIcon = ({color, size = 20}) => {
    return(
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z" fill="white"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M5.5 8.40002V13.8C5.506 15.02 6.453 16.005 7.615 16H15.115C15.327 16 15.499 15.822 15.5 15.6V10.2C15.494 8.98002 14.547 7.99502 13.384 8.00002H5.884C5.673 8.00002 5.501 8.17802 5.5 8.40002ZM15.5 10.509L18.967 8.13502C19.269 7.90502 19.5 7.95802 19.5 8.38502V15.624C19.5 16.104 19.212 16.049 18.967 15.874L15.5 13.5V10.509Z" fill="#5B36F2"/>
        </svg>
    );
}

export default ZoomIcon;